import { render, staticRenderFns } from "./CoverageGuarantee.vue?vue&type=template&id=995905c2"
import script from "./CoverageGuarantee.vue?vue&type=script&lang=js"
export * from "./CoverageGuarantee.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports